import { render } from "./myButton.vue?vue&type=template&id=44e3ae3d&scoped=true"
import script from "./myButton.vue?vue&type=script&lang=js"
export * from "./myButton.vue?vue&type=script&lang=js"

import "./myButton.vue?vue&type=style&index=0&id=44e3ae3d&scoped=true&lang=css"

import exportComponent from "/vercel/path0/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44e3ae3d"]])

export default __exports__